import React, { useEffect, useRef, useState } from 'react'
import DraggableItem from './dragableItem'
import RenderTable from '../../common/table'
import scissor from '../../../../src/assests/scissorImg.png'
const DragAndDropContainer = (props) => {
  const {
    items,
    isPrePrinted,
    width,
    height,
    headerHeigth,
    footerHeight,
    setItems,
    horizontal,
    vertical,
    tableInfo,
    marginInfo,
    showTable,
    onTableSelect,
    setIsTableSelected,
    font,
    isBold,
    isItalic,
    isUnderline,
    scale,
  } = props
  // console.log(props)
  const { row, col, tblWidth, tblHeight, alignment, isAlignment } = tableInfo
  const lastTwoItems = items?.slice(-2) // Get the last two items
  const [isSelecting, setIsSelecting] = useState(false)
  const [actionHistory, setActionHistory] = useState([])
  const maxHistoryLength = 5 // Maximum number of actions to keep in history
  const [selectionBox, setSelectionBox] = useState({
    startX: 0,
    startY: 0,
    endX: 0,
    endY: 0,
  })
  const containerRef = useRef(null)
  //useEffect to handle inside click of div selected items should be disselect
  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Check if the click target is inside the container
      const clickedInsideContainer = containerRef.current && containerRef.current.contains(event.target)

      // Check if the click target is an item or a descendant of an item
      const clickedOnItem = items.some((item) => {
        const itemElement = document.getElementById(item.id)
        return itemElement && itemElement.contains(event.target)
      })

      // Update items only if the click is inside the container and not on an item
      if (clickedInsideContainer && !clickedOnItem) {
        const updatedItems = items.map((item) => ({ ...item, isSelected: false }))
        setItems(updatedItems)
      }
    }

    document.body.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.body.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [items, containerRef, setItems])

  const undo = () => {
    if (actionHistory.length > 1) {
      setActionHistory((prevHistory) => {
        const newHistory = prevHistory.slice(0, -1)
        setItems(newHistory[newHistory.length - 1])
        return newHistory
      })
    }
  }
  useEffect(() => {
    // Listen for keyboard events
    const handleKeyDown = (event) => {
      // Check if the key pressed is 'Z' and the 'Ctrl' key is also pressed
      if (event.key === 'z' && event.ctrlKey) {
        // Perform undo operation
        undo()
      }
    }
    // Add event listener for keyboard events
    document.addEventListener('keydown', handleKeyDown)

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [undo])

  useEffect(() => {
    // Save the current state of items to the action history
    setActionHistory((prevHistory) => [...prevHistory, [...items]])
  }, [items])

  const handleDragStart = (e) => {
    const data = {
      offsetX: e.clientX - e.target.getBoundingClientRect().left - 1,
      offsetY: e.clientY - e.target.getBoundingClientRect().top - 1,
      id: e.target.id,
    }
    e.dataTransfer.setData('application/json', JSON.stringify(data))
  }
  const handleItemClick = (itemId) => {
    const a1 = items?.map((item) => (item.id === itemId ? { ...item, isSelected: !item.isSelected } : item))
    setItems(a1)
  }
  const handleDragOver = (e) => {
    e.preventDefault()
  }
  const handleDrop = (e) => {
    e.preventDefault()
    const droppedItem = e.dataTransfer.getData('application/json')
    const { id: droppedItemId, offsetX, offsetY } = JSON.parse(droppedItem)
    const containerRect = e.currentTarget.getBoundingClientRect()
    let droppedItemLeft = e.clientX - offsetX - containerRect.left
    let droppedItemTop = e.clientY - offsetY - containerRect.top
    let minLeft = marginInfo?.left //left marging
    let minTop = marginInfo?.up //top margin
    const ele = document.getElementById(droppedItemId)
    if (droppedItemLeft < minLeft) {
      droppedItemLeft = minLeft
    }
    if (droppedItemTop < minTop) {
      droppedItemTop = minTop
    }
    // Calculate maxLeft based on container width and marginInfo
    const maxLeft = containerRect.width - marginInfo?.right - ele?.offsetWidth
    // Ensure droppedItemLeft does not exceed maxLeft
    if (droppedItemLeft > maxLeft) {
      droppedItemLeft = maxLeft
    }
    // Calculate maxTop based on container height and the height of the dropped item
    let maxTop = containerRect.height - marginInfo?.down - ele?.offsetHeight
    // Check if the dropped item exceeds the maximum top position
    if (droppedItemTop > maxTop) {
      droppedItemTop = maxTop
    }
    const draggedItem = items?.find((item) => item.id === droppedItemId)
    if (draggedItem) {
      const updatedItems = items?.map((item) =>
        item.id === draggedItem.id
          ? {
              ...item,
              left: droppedItemLeft,
              top: droppedItemTop,
            }
          : item
      )

      setItems(updatedItems)
    } else {
      document.getElementById(droppedItemId).style.left = droppedItemLeft
      document.getElementById(droppedItemId).style.top = droppedItemTop
    }
  }
  const handleMouseDown = (e) => {
    setIsSelecting(true)
    const containerRect = e.currentTarget.getBoundingClientRect()
    setSelectionBox({
      startX: e.clientX - containerRect.left,
      startY: e.clientY - containerRect.top,
      endX: e.clientX - containerRect.left,
      endY: e.clientY - containerRect.top,
    })
  }

  const handleMouseMove = (e) => {
    if (isSelecting) {
      const containerRect = e.currentTarget.getBoundingClientRect()
      setSelectionBox({
        ...selectionBox,
        endX: e.clientX - containerRect.left,
        endY: e.clientY - containerRect.top,
      })
    }
  }

  const handleMouseUp = () => {
    if (isSelecting) {
      setIsSelecting(false)

      const minX = Math.min(selectionBox.startX, selectionBox.endX)
      const maxX = Math.max(selectionBox.startX, selectionBox.endX)
      const minY = Math.min(selectionBox.startY, selectionBox.endY)
      const maxY = Math.max(selectionBox.startY, selectionBox.endY)

      const updatedItems = items?.map((item) => {
        const itemRect = {
          left: item.left,
          top: item.top,
          right: item.left + 50, // Assuming width and height are both 50
          bottom: item.top + 50,
        }

        const isSelected = itemRect.left < maxX && itemRect.right > minX && itemRect.top < maxY && itemRect.bottom > minY

        return {
          ...item,
          isSelected,
        }
      })

      setItems(updatedItems)
    }
  }

  return (
    <div
      //zoomLevel={zoomLevel}
      ref={containerRef}
      id={props.id}
      style={{
        width: `${width || 200}mm`,
        height: `${height || 100}mm`,
        border: '1px solid #ccc',
        position: 'relative',
        background: 'white',
        margin: 'auto',
        textAlign: 'center',
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
      }}
      onDrop={(e) => handleDrop(e)}
      onDragOver={(e) => e.preventDefault()}
      onMouseMove={(e) => handleMouseMove(e)}
    >
      {/* Border for Top Margin */}
      <div
        style={{
          position: 'absolute',
          top: '0',
          // left: `${marginInfo?.left || 0}px`,
          // right: `${marginInfo?.right || 0}px`,
          left: '0px',
          right: '0px',
          height: `${marginInfo?.up || 0}px`,
          borderBottom: '2px dashed #0086FF', // Adjust color and size as needed
        }}
      ></div>
      {/* Border for Bottom Margin */}
      <div
        style={{
          position: 'absolute',
          bottom: '0',
          // left: `${marginInfo?.left || 0}px`,
          // right: `${marginInfo?.right || 0}px`,
          left: '0px',
          right: '0px',
          height: `${marginInfo?.down || 0}px`,
          borderTop: '2px dashed #0086FF', // Adjust color and size as needed
        }}
      ></div>
      {/* Border for Left Margin */}
      <div
        style={{
          position: 'absolute',
          left: '0',
          // top: `${marginInfo?.up || 0}px`,
          // bottom: `${marginInfo?.down || 0}px`,
          top: '0px',
          bottom: '0px',
          width: `${marginInfo?.left || 0}px`,
          borderRight: '2px dashed #0086FF', // Adjust color and size as needed
        }}
      ></div>
      {/* Border for Right Margin */}
      <div
        style={{
          position: 'absolute',
          right: '0',
          // top: `${marginInfo?.up || 0}px`,
          // bottom: `${marginInfo?.down || 0}px`,
          top: '0px',
          bottom: '0px',
          width: `${marginInfo?.right || 0}px`,
          borderLeft: '2px dashed #0086FF', // Adjust color and size as needed
        }}
      ></div>
      <div
        style={{
          borderBottom: `1px solid #ccc`,
          position: 'absolute',
          top: `${headerHeigth}mm`, //need to add margintop
          left: '0',
          right: '0',
        }}
      ></div>
      <div
        style={{
          borderTop: `1px solid #ccc`,
          position: 'absolute',
          bottom: `${footerHeight}mm`,
          left: '0',
          right: '0',
        }}
      ></div>
      {/*Separation Horizontal Line */}
      {/* <div
        style={{
          position: 'absolute',
          display: !horizontal || horizontal === '0' ? 'none' : '',
          top: `${horizontal}mm`,
          left: `${0}mm`,
          width: `${width}mm`, //ticket width
          height: '1px',
          backgroundColor: 'gray',
          borderBottom: `1px dashed #ccc`,
          backgroundImage: 'url(http://i.stack.imgur.com/cXciH.png)',
        }}
      ></div> */}
      {/*Separation Horizontal Line with scissors*/}
      <div
        style={{
          height: '43px',
          width: '100%',
          backgroundImage: 'url("http://i.stack.imgur.com/cXciH.png")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '18px 12px',
          position: 'relative',
          top: `${horizontal - 6}mm`,
          display: !horizontal || horizontal === '0' ? 'none' : '',
        }}
      ></div>
      <div
        style={{
          position: 'relative',
          top: `${horizontal - 6}mm`, //horizontal-43px+22px=6mm
          borderBottom: `1px dashed black`,
          marginTop: ' -22px',
          display: !horizontal || horizontal === '0' ? 'none' : '',
        }}
      ></div>

      {/*Separation Vertical Line */}
      {/* <div
        style={{
          position: 'absolute',
          top: `${0}mm`,
          left: `${vertical}mm`,
          display: !vertical || vertical === '0' ? 'none' : '',
          width: '1px',
          height: `${height}mm`, //ticket height
          backgroundColor: 'gray',
          borderLeft: `1px dashed #ccc`,
        }}
      ></div> */}
      <div
        style={{
          width: '43px',
          height: '100%',
          backgroundImage: 'url("http://i.stack.imgur.com/cXciH.png")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: '18px 12px',
          position: 'relative',
          left: `${vertical - 6}mm`,
          // display: 'inline-block',
          transform: 'rotate(270deg)',
          display: !vertical || vertical === '0' ? 'none' : 'inline-block',
        }}
      ></div>
      <div
        style={{
          position: 'relative',
          left: `${vertical - 12}mm`,
          borderRight: `1px dashed black`,
          marginRight: '-22px',
          height: '100%',
          display: !vertical || vertical === '0' ? 'none' : 'inline-block',
        }}
      ></div>
      {items?.map((item) => (
        <DraggableItem
          key={item.id}
          {...item}
          handleDragStart={handleDragStart}
          handleDragOver={handleDragOver}
          handleItemClick={handleItemClick}
          items={items}
          setItems={setItems}
          isPrePrinted={isPrePrinted}
        />
      ))}
      {isPrePrinted &&
        lastTwoItems.map((item) => (
          <DraggableItem
            key={item.id}
            {...item}
            handleDragStart={handleDragStart}
            handleDragOver={handleDragOver}
            handleItemClick={handleItemClick}
            items={items}
            setItems={setItems}
          />
        ))}
      {showTable && (
        <RenderTable
          id={showTable}
          rows={row}
          cols={col}
          fontSize={font}
          isBold={isBold}
          isItalic={isItalic}
          isUnderline={isUnderline}
          cellHeight={tblHeight}
          cellWidth={tblWidth}
          alignment={alignment}
          isAlignment={isAlignment}
          onTableSelect={onTableSelect}
          setIsTableSelected={setIsTableSelected}
          handleDragStart={handleDragStart}
          handleDragOver={handleDragOver}
        />
      )}
    </div>
  )
}

export default DragAndDropContainer
